import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import AlertModal from '../alert-modal/AlertModal.jsx';
import FormModal from '../form-modal/FormModal.jsx';

import s from './ModalWrapper.module.scss';

const determineForm = name => {
    switch (name) {
        case 'alert':
            return AlertModal;
        case 'form':
            return FormModal;
        default:
            return FormModal;
    }
};

const ModalWrapper = ({ banner, editableValues, handleChange, options }) => {
    const ModalType = determineForm(options.name);
    return (
        <Modal className={s.modal} overlayClassName={s.overlay} isOpen>
            <ModalType banner={banner} handleChange={handleChange} options={options} editableValues={editableValues} />
        </Modal>
    );
};

ModalWrapper.propTypes = {
    banner: PropTypes.object.isRequired,
    editableValues: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    options: PropTypes.object.isRequired,
};

export default ModalWrapper;
